module.exports = __webpack_public_path__ + "img/contact-bg.839bb80f.jpg";